import React, { Component } from 'react';
import ReactPaginate from 'react-paginate';
import { Redirect } from 'react-router';
import { Link } from 'react-router-dom';
import '../common/MdPage.css';
import '../Pagination.css';
import * as constantClass from '../fileWithConstants';
import { ChevronLeftIcon } from '../common/mdPageIcons';
import { createPagedGridController } from '../../hooks/pagedGridClassAdapter';
import * as actasService from '../../services/actas/actasService';
import {
  classifyActasError,
  findAlumnosSinResultadoCargado,
  toSaveActaCursadaPayload,
  validateActaCursadaResultados
} from '../../services/actas/actasDto';
import Select from '../common/AppSelect';
import { ConfirmDialog } from '../common/ConfirmDialog';

export class CargarActaCursada extends Component {
  static displayName = CargarActaCursada.name;

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      perPage: 10,
      paginationData: [],
      pageCount: 1,
      forcePage: 0,
      showErrorMessage: false,
      errorMessage: '',
      alumnos: [],
      materia: '',
      id: this.props.match.params.id,
      resultados: [],
      alumnosPendientesIds: [],
      showSuccessDialog: false,
      success: false
    };
    this.grid = createPagedGridController({
      fetchPage: (query) => actasService.listActaCursadaDetalle(this.state.id, query),
      defaultPageSize: 10,
      onChange: (gridState) => this.applyGridState(gridState)
    });
    this.handlePageClick = this.handlePageClick.bind(this);
    this.handleConfirmButton = this.handleConfirmButton.bind(this);
  }

  handleConfirmButton = () => {
    const pendientes = findAlumnosSinResultadoCargado(this.state.alumnos, this.state.resultados);
    if (!validateActaCursadaResultados(this.state.alumnos, this.state.resultados)) {
      this.setState({
        showErrorMessage: true,
        errorMessage: 'Hay alumnos sin cargar el resultado',
        alumnosPendientesIds: pendientes.map((alumno) => alumno.detalleActaCursadaCod)
      });
      return;
    }

    this.setState({
      showErrorMessage: false,
      errorMessage: '',
      alumnosPendientesIds: []
    });
    this.postNotas();
  };

  handleSuccessDialogClose = () => {
    this.setState({ showSuccessDialog: false, success: true });
  };

  async componentDidMount() {
    const canAccess = await constantClass.canAccess('WWActasCursado');
    if (canAccess) {
      this.populateData();
    }
  }

  applyGridState(gridState) {
    this.setState({
      paginationData: gridState.items,
      pageCount: gridState.pageCount,
      perPage: gridState.pageSize,
      loading: gridState.loading,
      forcePage: gridState.forcePage
    });
  }

  handlePageClick = (e) => {
    this.grid.handlePageClick(e).catch((error) => this.handleActasError(error));
  };

  getResultadoValue = (detalleId) => {
    const entry = this.state.resultados.find((r) => r.id === detalleId);
    return entry?.resultado ?? '';
  };

  isAlumnoPendiente = (detalleId) => this.state.alumnosPendientesIds.includes(detalleId);

  handleResultadoChange = (detalleId, option) => {
    const resultado = option?.value ?? '';
    this.setState((prevState) => {
      const index = prevState.resultados.findIndex((r) => r.id === detalleId);
      const resultados = index >= 0
        ? prevState.resultados.map((entry, entryIndex) => (
          entryIndex === index ? { ...entry, resultado } : entry
        ))
        : [...prevState.resultados, { id: detalleId, resultado }];

      const alumnosPendientesIds = resultado
        ? prevState.alumnosPendientesIds.filter((id) => id !== detalleId)
        : prevState.alumnosPendientesIds;

      return { resultados, alumnosPendientesIds };
    });
  };

  renderalumnosTable(alumnos) {
    const options = [
      { value: 'R', label: 'Regular' },
      { value: 'L', label: 'Libre' },
      { value: 'P', label: 'Promoción' },
      { value: 'E', label: 'Equivalencia' },
    ];
    return (
      <div className="md-page__table-card">
        <table className="md-page__table" aria-labelledby="cargar-acta-cursada-title">
          <thead>
            <tr>
              <th scope="col">DNI</th>
              <th scope="col">Nombre y Apellido</th>
              <th scope="col">Resultado</th>
            </tr>
          </thead>
          <tbody>
            {alumnos.map((alumno) => {
              const detalleId = alumno.detalleActaCursadaCod;
              const rowClassName = this.isAlumnoPendiente(detalleId)
                ? 'md-cargar-acta-cursada__row--pending'
                : undefined;

              return (
              <tr key={detalleId} className={rowClassName}>
                <td>{alumno.alumnoDni}</td>
                <td>{alumno.alumnoNombre}</td>
                <td>
                  <Select
                    options={options}
                    value={this.getResultadoValue(detalleId)}
                    disabled={this.state.loading}
                    placeholder="Seleccioná el resultado"
                    onChange={(option) => this.handleResultadoChange(detalleId, option)}
                  />
                </td>
              </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }

  render() {
    if (this.state.success) {
      return <Redirect to="/md-acur" />;
    }

    const listLoading = this.state.loading && this.state.paginationData.length === 0;
    let contents = listLoading
      ? <p className="md-page__loading"><em>Cargando datos...</em></p>
      : (
        <>
          <div className="md-cargar-acta-cursada__confirm-bar">
            <button
              type="button"
              className="md-page__form-btn md-page__form-btn--primary"
              onClick={this.handleConfirmButton}
              disabled={this.state.loading}
            >
              Confirmar
            </button>
          </div>
          {this.renderalumnosTable(this.state.paginationData)}
        </>
      );

    const materiaDisplay = this.state.materia.trim();

    return (
      <div className="md-page md-cargar-acta-cursada">
        <Link className="md-page__back-link" to="/md-acur">
          <ChevronLeftIcon />
          Volver al listado
        </Link>

        <div className="md-page__header">
          <h1 id="cargar-acta-cursada-title" className="md-page__title">Cargar Resultados de Acta de Cursada</h1>
        </div>
        <p className="md-page__subtitle">
          Asigne el resultado de cada alumno y confirme para guardar el acta.
        </p>

        <div className="md-page__feedback" aria-live="polite" role="status">
          {this.state.showErrorMessage ? (
            <div className="md-page__error" role="alert">{this.state.errorMessage}</div>
          ) : null}
        </div>

        <div className="md-page__form-card">
          <div className="md-page__field md-page__field--inline-readonly">
            <span className="md-page__field-label">Materia</span>
            <div
              className="md-page__field-readonly md-page__field-readonly--single-line"
              title={materiaDisplay}
            >
              {materiaDisplay}
            </div>
          </div>
        </div>

        {contents}

        {!this.state.loading && this.state.pageCount > 1 ? (
          <div className="md-page__pagination">
            <ReactPaginate
              previousLabel="Anterior"
              nextLabel="Siguiente"
              breakLabel="..."
              pageCount={this.state.pageCount}
              marginPagesDisplayed={2}
              pageRangeDisplayed={5}
              onPageChange={this.handlePageClick}
              forcePage={this.state.forcePage}
              containerClassName="pagination"
              activeClassName="active"
            />
          </div>
        ) : null}

        {this.renderSuccessDialog()}
      </div>
    );
  }

  renderSuccessDialog() {
    return (
      <ConfirmDialog
        open={this.state.showSuccessDialog}
        title="Acta cargada"
        message="El acta se guardó correctamente."
        confirmLabel="Confirmar"
        showCancel={false}
        variant="primary"
        onConfirm={this.handleSuccessDialogClose}
        onCancel={this.handleSuccessDialogClose}
      />
    );
  }

  handleActasError(error) {
    const outcome = classifyActasError(error);
    if (outcome.type === 'timeout') {
      constantClass.RedirectToLogin();
      return;
    }
    this.setState({
      showErrorMessage: true,
      errorMessage: outcome.message,
      loading: false
    });
  }

  async populateData() {
    try {
      actasService.clearActaCursadaDetalleCache(this.state.id);
      const returnModel = await actasService.getActaCursadaDetalle(this.state.id);
      actasService.seedActaCursadaDetalleCache(this.state.id, returnModel);
      this.setState({
        alumnos: returnModel,
        materia: returnModel.length > 0
          ? `${returnModel[0].materiaCarreraNombre.trim()} - ${returnModel[0].carreraNombre.trim()}`
          : '',
        resultados: returnModel.reduce((acc, alumno) => {
          const resultado = String(alumno.detalleActaCursadaResultado ?? '').trim();
          if (!resultado) {
            return acc;
          }
          acc.push({ id: alumno.detalleActaCursadaCod, resultado });
          return acc;
        }, []),
        alumnosPendientesIds: []
      });
      await this.grid.load();
    } catch (error) {
      this.handleActasError(error);
    }
  }

  async postNotas() {
    this.setState({ loading: true });
    try {
      await actasService.saveActaCursada(toSaveActaCursadaPayload(this.state.resultados));
      this.setState({ loading: false, showSuccessDialog: true });
    } catch (error) {
      this.handleActasError(error);
    }
  }
}
